import { t } from '@fondof-ui/lib/translations'
import * as z from 'zod'

const customErrorMap: z.ZodErrorMap = (error, ctx) => {
  if (error.code === 'too_small') {
    return {
      message: t('validation.tooSmall', {
        missing: String(Number(error.minimum) - ctx.data.length),
      }),
    }
  }

  if (error.code === 'too_big') {
    return {
      message: t('validation.tooBig', { max: String(error.maximum) }),
    }
  }

  if (error.code === 'invalid_string' && error.validation === 'email') {
    return { message: t('validation.email') }
  }

  if (error.code === 'invalid_type') {
    return { message: t('validation.required') }
  }

  // fall back to default message!
  return { message: ctx.defaultError }
}

z.setErrorMap(customErrorMap)

export { z }
